import {useMemo} from 'react';
import {usePressReleaseQuery} from '../api/queries/use-press-release-query';

export const usePressReleaseImagesWithoutPixta = () => {
  const {data} = usePressReleaseQuery();

  // PIXTA 画像 (fileName に "pixta_" が含まれている) を画像を除外する
  const images = useMemo(() => {
    if (data === undefined) return [];

    return data.images.filter((image) => !image.fileName.includes('pixta_'));
  }, [data]);

  return {images};
};
